import { BlobType } from '@lib/commons/enums/blob-type.enum';

export function getBlobFileType(fileExtension: string): BlobType {
  switch (fileExtension?.toLowerCase()) {
    case 'pdf':
      return BlobType.PDF;
    case 'jpg':
    case 'jpeg':
      return BlobType.JPEG;
    case 'png':
      return BlobType.PNG;
    default:
      return BlobType.PDF;
  }
}

export function getFileExtension(fileName: string): string {
  return fileName?.split('.').pop() || '';
}

export function createBlobUrl(response: ArrayBuffer, fileType: BlobType): string {
  const blob = new Blob([response], { type: fileType });

  return URL.createObjectURL(blob);
}

export function openFileInNewTab(response: ArrayBuffer, fileName: string): void {
  const fileExtension = getFileExtension(fileName);
  const blobType = getBlobFileType(fileExtension);
  const blobUrl = createBlobUrl(response, blobType);
  window.open(blobUrl, '_blank');
}
